import React from 'react';

export const FormatedPercent = (props) => {
    let value = props.content > 0 ? props.content : (props.content * -1);
    let fixed = props.fixed ? props.fixed : 0;
    const colorClass = props.content < 0 ? 'negNumber' :
        props.type === 'mobile' ? 'posNumber' : '';
    
    return (
        <span className={colorClass}>
            {
                props.content < 0 && '('
            }
            {
                ((props.content && !isNaN(props.content)) ? value.toFixed(fixed) : 0)
            }
            %
            {
                props.content < 0 && ')'
            }
        </span>
    )
}

export default FormatedPercent;
